export default [{
  id: 1,
  name: '在职在编人员'
}, {
  id: 2,
  name: '文职人员'
}, {
  id: 3,
  name: '聘用人员'
}]



// WEBPACK FOOTER //
// ./src/comm/config/high-tech/PlayerType.js